import { useSelector } from 'react-redux';
import { ClientRegistrationState } from '@common/model/client/registration/registrationState';
import { useMemo } from 'react';
import { registrationStateSelector, registrationStepSelector } from '../api';
import { FlowStep } from './flow';

export type RegistrationMeta = {
  state: Partial<ClientRegistrationState>;
  currentStepNumber: number;
  totalSteps: number;
  step: FlowStep | null;
};

/**
 * Предоставляет данные о ходе регистрации
 */
export const useRegistrationMeta = (): RegistrationMeta => {
  const state = useSelector(registrationStateSelector);
  const step = useSelector(registrationStepSelector);
  return useMemo(() => {
    return { state, step, currentStepNumber: step?.currentStepNumber || 0, totalSteps: step?.totalSteps || 0 };
  }, [state, step]);
};
